export class TableColumn {
  title: string = "";
  width: number = 0;
  xPosition: number = 0;
  isPriceColumn: boolean = false;

  constructor(title: string, xPosition: number, width: number, isPriceColumn = false) {
    this.title = title;
    this.xPosition = xPosition;
    this.width = width;
    this.isPriceColumn = isPriceColumn;
  }
}
